// src/SEO.js
import { useEffect } from 'react';

const SEO = ({ 
  title = "Naija Petrol Prices - Real-Time Fuel Prices Across Nigeria",
  description = "Find the latest petrol (PMS), diesel (AGO), kerosene (DPK), and cooking gas (LPG) prices from filling stations across Nigeria. Updated in real-time by station owners and community members.",
  keywords = "petrol prices Nigeria, fuel prices, diesel prices, LPG prices, cooking gas prices, NNPC, filling stations, Lagos fuel prices, Abuja petrol prices",
  ogImage = "/logo.png",
  url = ""
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Standard meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);

    // Open Graph tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', window.location.origin + ogImage, true);
    updateMetaTag('og:url', window.location.origin + url, true);
    updateMetaTag('og:type', 'website', true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', window.location.origin + ogImage);
    updateMetaTag('twitter:site', '@PetrolNaija');

    // Mobile optimization
    updateMetaTag('viewport', 'width=device-width, initial-scale=1, maximum-scale=5');
    updateMetaTag('theme-color', '#16a34a');

  }, [title, description, keywords, ogImage, url]);

  return null;
};

export default SEO;
